export default __webpack_public_path__ + "static/media/talan_group.90e380f6.svg";